function getTimezone() {
  // NOTE: timezone is hardcoded to Europe:Berlin.
  // Initially "jstimezonedetect.determine()" was used
  // but the problem is because "determine" is to detailed with timezones!
  // Fishnet only supports a certain set of all the timezones.
  return 'Europe:Berlin';
}

export default getTimezone;
